import { render, staticRenderFns } from "./UserDeckList.vue?vue&type=template&id=1d7798eb&"
import script from "./UserDeckList.vue?vue&type=script&lang=js&"
export * from "./UserDeckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports